
import { mapGetters } from "vuex";
// import * as types from "../vuex/types";
// import api from "../vuex/api/index";

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
  },
  head() {
    return {
      title: 'Why Choose American Credit? | Expertise | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'American Credit provides quick business lending options to owners in need. No long waiting periods or runarounds. Quick results & speedy funding. Apply today!'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'asset-based loan, equipment loan, AR Invoice financing, Business Loans, small business financing, small business credit, american credit'
        }
      ]
    }
  }
};
